import { render, staticRenderFns } from "./web-publish-button.vue?vue&type=template&id=c596fab4&scoped=true&"
import script from "./web-publish-button.vue?vue&type=script&lang=js&"
export * from "./web-publish-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c596fab4",
  null
  
)

export default component.exports